import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { NAV, ASSETS, BRAND } from "@/lib/constants";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-midnight/85 backdrop-blur-xl border-b border-slate-soft"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-brand-link"
          className="flex items-center gap-3 group"
        >
          <img
            src={ASSETS.brandLogoLockup}
            alt="The Next Stage"
            className="h-14 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]"
            loading="eager"
          />
          <span className="hidden sm:block font-manrope text-[10px] uppercase tracking-[0.32em] text-muted-ink border-l border-slate-soft pl-3">
            Public Speaking
            <br />
            Showcase
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" data-testid="primary-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/"}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-bebas tracking-[0.22em] text-sm px-3 py-2 transition-colors ${
                  isActive
                    ? "text-gold-bright"
                    : "text-soft-gray hover:text-gold"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/apply"
            data-testid="header-apply-cta"
            className="btn-gold ml-4 text-[12px] py-3 px-5"
          >
            Apply To Speak
          </Link>
        </nav>

        <div className="lg:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button
                data-testid="mobile-nav-trigger"
                aria-label="Open menu"
                className="p-2 text-white hover:text-gold transition"
              >
                <Menu size={26} />
              </button>
            </SheetTrigger>
            <SheetContent
              side="right"
              className="bg-midnight border-l border-slate-soft text-white w-[88%] sm:w-[420px]"
            >
              <div className="flex items-center justify-between mb-10">
                <div className="font-bebas text-2xl tracking-[0.18em] text-white">
                  Menu
                </div>
                <button
                  onClick={() => setOpen(false)}
                  aria-label="Close menu"
                  className="p-1 text-white hover:text-gold"
                >
                  <X size={22} />
                </button>
              </div>
              <nav className="flex flex-col gap-1" data-testid="mobile-nav">
                {NAV.map((item) => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    end={item.path === "/"}
                    onClick={() => setOpen(false)}
                    data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
                    className={({ isActive }) =>
                      `font-shoulders font-bold uppercase tracking-[0.18em] text-2xl py-3 border-b border-slate-soft transition-colors ${
                        isActive ? "text-gold-bright" : "text-soft-gray"
                      }`
                    }
                  >
                    {item.label}
                  </NavLink>
                ))}
              </nav>
              <Link
                to="/apply"
                onClick={() => setOpen(false)}
                data-testid="mobile-apply-cta"
                className="btn-gold mt-10 w-full"
              >
                Apply To Speak
              </Link>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
